/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestService } from '../../RestService';

class AlarmService extends RestService {
    /** @ngInject */
    constructor($q, resource, $httpParamSerializerJQLike, $log) {
        super($q, resource,  $httpParamSerializerJQLike, $log, false);
        $log.debug('Service \'AlarmService\' loaded');
    }
}

export { AlarmService };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/alarm/service/AlarmService.js